export default __webpack_public_path__ + "static/media/camera.d028c479.svg";